import React, { useState, useEffect } from "react";
import Container from "../../../../components/Cards/Container/Container";
import Typography from "../../../../components/Typography/Typography";
import {
  DASHBOARD_FEATURES,
  EMPTY_CONTRACT_DRAFTING_DATA,
} from "../../constants";
import DraftingDashboardStyles from "./DraftingDashboard.module.scss";
import ListAltCheckSvg from "../../../../assets/images/list_alt_check.svg";
import { Avatar } from "@mui/material";
import TemplateOptions from "./TemplateOptions";
import UploadDoc from "../../../../components/UploadDoc/UploadDoc";
import Button from "../../../../components/Button/Button";
import rightArrowSvg from "../../../../assets/images/right_arrow.svg";
import { DASHBOARD_ENTITIES } from "../../../../common/constants";
import Table from "../../../../components/Table/Table";
import {
  reviewPendingApiProp,
  TableTypes,
} from "../../../ManageContract/constants";
import DownloadSvg from "../../../../assets/images/download_primary_icon.svg";
import ExcelSvg from "../../../../assets/images/excel_icon.svg";
import CloseSvg from "../../../../assets/images/close.svg";
import { useAppDispatch, useAppSelector } from "../../../../hooks/store";
import { getSampleDownloadIntakeForm } from "../../../../services/FileUpload.service";
import { getDraftingTemplatesList } from "../../../../services/common.service";
import {
  getContractDraftingTemplates,
  removeDraftingFile,
  updateContractDraftingData,
} from "../../store/dashboard.thunk";
import WhiteRightArrowSvg from "../../../../assets/images/white_right_arrow.svg";
import { generateContractDrafting } from "../../../../services/contracts.service";
import { getTableDataThunk } from "../../../../store/thunks/table.thunk";
import { getToast } from "../../../../common/utils";

import infoIconSvg from "../../../../assets/images/UserTable/InfoIcon.svg";
import Tooltip from "../../../../components/Tooltip/Tooltip";

const DraftingDashboard = (props: any) => {
  const [selectedValue, setSelectedValue] = useState<string>("Search Template");
  const { headerText } = props;
  const dispatch = useAppDispatch();
  const isDrafting = headerText === DASHBOARD_FEATURES.CONTRACT_DRAFTING;
  const [openModal, setOpenModal] = useState(false);
  const [isTemplateSelected, setIsTemplateSelected] = useState(false);
  const [loader, setLoading] = useState(false);

  const tableData = useAppSelector(
    (store) => store?.rootReducer?.tableInfoReducer
  )?.data;

  const {
    intakeFormValidated,
    file_name,
    fileUpload,
    templateOptions,
    selectedTemplate,
    docId,
  } = useAppSelector(
    (store) => store?.rootReducer?.vscDashboardReducer
  )?.contractDrafting;

  const tableDataInData = tableData?.[TableTypes.DRAFTING_DASHBOARD]?.tableData;
  const tableDataCount = tableDataInData?.count;
  const draftingUploadingFile = fileUpload?.isUploading;
  const draftingFileUploaded = fileUpload?.uploaded;

  const truncateString = (str: string, num: number) => {
    if (str.length <= num) {
      return str;
    }
    return str.slice(0, num) + "...";
  };

  // const reTriggerApi = () => {};

  const handleDownload = async () => {
    if (!selectedTemplate?.id) {
      getToast("Error", "Please select a template");
      return;
    }
    try {
      const templateId = selectedTemplate?.id;
      const response = await getSampleDownloadIntakeForm(templateId);

      if (response?.signed_url_termsheet) {
        const link = document.createElement("a");
        link.href = response.signed_url_termsheet;
        link.download = "IntakeForm_Template.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        getToast("Error", "Error in Downloading Intake Form");
      }
    } catch (error) {
      getToast("Error", "Error in Downloading Intake Form");
    }
  };

  const handleUploadIntakeForm = () => {
    if (!selectedTemplate?.id) {
      getToast("Error", "Please Choose a Template");
      return;
    }
    setOpenModal(true);
  };

  useEffect(() => {
    dispatch(getContractDraftingTemplates());
  }, [dispatch]);

  const handleTemplateChange = (value: string, template: any) => {
    setSelectedValue(value);
    setIsTemplateSelected(true);
    dispatch(updateContractDraftingData({ selectedTemplate: template }));
  };

  const handleFileCrossClick = (e: any) => {
    e?.preventDefault();
    dispatch(removeDraftingFile());
  };
  const handleGenerateClick = async () => {
    try {
      setLoading(true);
      await generateContractDrafting({
        doc_id: docId,
        term_sheet_id: selectedTemplate?.id,
      });
      getToast("Success", "Contract Generated Successfully");
      dispatch(
        getTableDataThunk(
          TableTypes.DRAFTING_DASHBOARD,
          1,
          tableData?.[TableTypes.DRAFTING_DASHBOARD]?.toBeRetrieved
        )
      );
      dispatch(removeDraftingFile());
      dispatch(updateContractDraftingData(EMPTY_CONTRACT_DRAFTING_DATA));
      setIsTemplateSelected(false);
      setSelectedValue("Search Template");
    } catch (error) {
      getToast("Error", "Contract Could'nt Be Generated");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container
      className={`${
        !isDrafting ? DraftingDashboardStyles.customContainer : ""
      }`}
    >
      <div className={DraftingDashboardStyles.cdContainer}>
        <div className={DraftingDashboardStyles.draftingActionsContainer}>
          <div className={DraftingDashboardStyles.leftContainer}>
            <div className={DraftingDashboardStyles.leftHeader}>
              <div className={DraftingDashboardStyles.draftingIcon}>
                <img src={ListAltCheckSvg} alt="" />
              </div>
              <Typography fontWeight={700} fontSize={12} color="#3474E0">
                Generate New Contract
              </Typography>
            </div>

            <div className={DraftingDashboardStyles.leftCardContent}>
              <div className={DraftingDashboardStyles.templateOptionsWrapper}>
                <div className={DraftingDashboardStyles.templateOptionsHeader}>
                  <Avatar
                    style={{
                      backgroundColor: "#3474E00D",
                      color: "#3474E0",
                      border: "1px solid #1E88E5",
                      width: "24px",
                      height: "24px",
                      fontSize: "12px",
                      fontWeight: "700",
                      fontFamily: "Google Sans",
                    }}
                  >
                    {1}
                  </Avatar>
                  <Typography fontWeight={400} fontSize={12} color="#5F6376">
                    Choose a template to start drafting your Contract
                  </Typography>
                </div>
                <div className={DraftingDashboardStyles.templateOptions}>
                  <TemplateOptions
                    options={templateOptions?.data}
                    onChange={handleTemplateChange}
                    selectedValue={selectedValue}
                    disabled={loader}
                  />
                </div>
              </div>

              <div className={DraftingDashboardStyles.uploadWrapper}>
                <div className={DraftingDashboardStyles.uploadHeader}>
                  <Avatar
                    style={{
                      backgroundColor: "#3474E00D",
                      color: "#3474E0",
                      border: "1px solid #1E88E5",
                      width: "24px",
                      height: "24px",
                      fontSize: "12px",
                      fontWeight: "700",
                      fontFamily: "Google Sans",
                    }}
                  >
                    {2}
                  </Avatar>
                  <Typography fontWeight={400} fontSize={12} color="#5F6376">
                    Upload a intake form to get started with Contract Drafting
                  </Typography>
                </div>

                <>
                  {draftingUploadingFile || draftingFileUploaded ? (
                    <div className={DraftingDashboardStyles.uploadFileWrapper}>
                      <div className={DraftingDashboardStyles.uploadedFileName}>
                        <img src={ExcelSvg} alt="" />
                        <Typography
                          fontSize={12}
                          fontWeight={400}
                          color="#000000CC"
                        >
                          <Tooltip title={file_name || ""} placement="top">
                            {truncateString(file_name || "", 20)}
                          </Tooltip>
                        </Typography>
                      </div>
                      {!loader && (
                        <img
                          src={CloseSvg}
                          alt=""
                          onClick={handleFileCrossClick}
                        />
                      )}
                    </div>
                  ) : (
                    <Button
                      variant="outlined"
                      style={{
                        backgroundColor:
                          !isTemplateSelected || loader ? "#e0e0e0" : "#fff",
                        borderColor:
                          isTemplateSelected && !loader ? "#3474E0" : "#ccc",
                        color:
                          isTemplateSelected && !loader
                            ? "#3474E0"
                            : "rgba(0, 0, 0, 0.26)",
                        borderRadius: "24px",
                        padding: "4px 12px",
                        width: "95%",
                      }}
                      fullWidth={true}
                      className={DraftingDashboardStyles.uploadButton}
                      onClick={handleUploadIntakeForm}
                      disabled={!isTemplateSelected || loader}
                    >
                      Upload Intake Form
                    </Button>
                  )}
                </>

                <Typography
                  fontWeight={400}
                  fontSize={12}
                  color="#00000099"
                  marginBottom={4}
                  marginTop={10}
                  style={{ marginTop: "20px" }}
                >
                  <span style={{ display: "flex", alignItems: "center" }}>
                    Not sure what to upload?{" "}
                    <Tooltip
                      title="Accepted File formats- .xlsx"
                      placement="right"
                    >
                      <img
                        src={infoIconSvg}
                        alt="Info Icon"
                        style={{
                          width: "10px",
                          height: "10px",
                          marginLeft: "4px",
                          color: "#000000",
                        }}
                      />
                    </Tooltip>
                  </span>
                </Typography>
                <div
                  style={{
                    display: "flex",
                    gap: "4px",
                    alignItems: "center",
                    marginBottom: "12px",
                  }}
                >
                  <img src={DownloadSvg} alt="" />
                  <button
                    onClick={handleDownload}
                    style={{
                      background: "none",
                      border: "none",
                      color: "#3474E0",
                      fontSize: "12px",
                      fontWeight: "400",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                  >
                    Download Template
                  </button>
                </div>

                {/* <span className={DraftingDashboardStyles.acceptedText}>
                  Accepted File formats- .xlsx
                </span> */}
              </div>
            </div>
          </div>
          <div className={DraftingDashboardStyles.generateButtonWrapper}>
            <Button
              style={{
                borderRadius: "24px",
                width: "98%",
                fontWeight: "400",
                fontSize: "12px",
                padding: "4px 12px",
              }}
              fullWidth={true}
              className={DraftingDashboardStyles.generateButton}
              disabled={!fileUpload?.uploaded}
              startIcon={
                !fileUpload?.uploaded ? (
                  <img src={rightArrowSvg} alt="" />
                ) : (
                  <img src={WhiteRightArrowSvg} alt="" />
                )
              }
              onClick={handleGenerateClick}
              loading={loader}
            >
              Generate Contract
            </Button>
          </div>
        </div>
        <div className={DraftingDashboardStyles.draftingTableContainer}>
          <div className={DraftingDashboardStyles.headerRightSide}>
            <Avatar
              style={{
                width: "42px",
                height: "42px",
                fontSize: "16px",
                fontWeight: "500",
                fontFamily: "Google Sans",
                backgroundColor: "#3474E00D",
                color: "#3474E0",
                border: "1px solid #1E88E5",
              }}
            >
              {tableDataCount || 0}
            </Avatar>
            <span className={DraftingDashboardStyles.headerText}>
              <Typography fontWeight={500} fontSize={14} color="#3474e0">
                All Generated Contracts
              </Typography>
              <Typography
                fontWeight={400}
                fontSize={12}
                color="#00000099"
                className={DraftingDashboardStyles.subHeaderText}
              >
                Number of generated contracts
              </Typography>
            </span>
          </div>
          <div style={{ height: "85%" }}>
            <Table
              entity={TableTypes.DRAFTING_DASHBOARD}
              apiProps={reviewPendingApiProp}
            />
          </div>
        </div>
      </div>
      <UploadDoc
        openModal={openModal}
        setOpenModal={setOpenModal}
        dashboardEntity={DASHBOARD_ENTITIES.CONTRACT_DRAFTING}
        // postUpload={reTriggerApi}
      />
    </Container>
  );
};

export default DraftingDashboard;
